  import 'semantic-ui-css/semantic.min.css'

  import { React , Suspense , useEffect, useState  } from 'react';
  import {
    useLoaderData , useNavigate 
  } from "react-router-dom";

  import Loading from './Loading';
  import ResultList from './ResultList';
  import Filters from './Filters';
  import ApplicationHeader from './Header';
  import ApplicationFooter from './Footer';

  import './translations/i18n';
  import { useTranslation  } from 'react-i18next';

  import "/node_modules/flag-icons/css/flag-icons.min.css";
  import useWindowDimensions from './useWindowDimensions'
  import { Container , Header, Input, Grid , Icon, Segment, Button, Sidebar , Label , Divider } from 'semantic-ui-react';
  const pjson = require('../package.json')
  const homep = (!!pjson.homepage) ? pjson.homepage : '/'
  const shareUrl = `${window.location.origin}${homep}`

  const  App = () => {
      const data = useLoaderData()
      const epubs = data.epub
      const user = data.user
      const navigate = useNavigate()
      const [results , setResults ] = useState(Object.entries(epubs.data)) 
      const [ input , setInput] = useState("")
      const [ filters , setFilters ] = useState(epubs.filters)
      const [ myFilters , setMyFilters ] = useState({})
      const { t , i18n } = useTranslation();
      const [ activePage , setActivePage ] = useState(1)
      const {height, width} = useWindowDimensions();
      const [ filterModal , setFilterModal ] = useState(false)
      const [ filterCount , setFilterCount] = useState(epubs.filterCount)
      const [ myFilterCount , setMyFilterCount ] = useState(0)
      const [ url , setUrl] = useState('')
      const [ copied , setCopied ] = useState(false)
      const [ filterList , ] = useState(Object.keys(epubs.filters))
      i18n.on('languageChanged', (lng) => {
        document.documentElement.setAttribute('lang', lng)
        document.title = t('MainTitle') + ' - ' + t('Organisation')
      })

      useEffect(() => {
        setTimeout(() => setCopied(false) , 4000)
      },[copied])

      const copyToClipBoard = (text) => {
        navigator.clipboard.writeText(text).then(
          () => {
            setCopied(true)
          },
          () => {
            console.error('Error klembord')
          },
        );
      }

      const resetAllFilters = () => {
        sessionStorage.removeItem('savedSearch')
        setMyFilterCount(0) 
        setInput("")
        setActivePage(1)
        setFilters(obj => ({...obj , trefwoorden : {}}))
        for(const groep in filters) {
          for(const sel in filters[groep]) {
            setFilters(obj => ({ ...obj , [groep] : {...obj[groep] ,  [sel] : false}}))
          }
        }
        setResults(Object.entries(epubs.data))
      }

      useEffect(() => {
        if(width > 767 ) {
          setFilterModal(false)
        }
      },[width])

      useEffect(() => {
        document.title = t('MainTitle') + ' - ' + t('Organisation')
        let saved = false
        let savedSearch = {}
        if(sessionStorage.getItem('savedSearch')) {
          saved = true
          savedSearch = JSON.parse(sessionStorage.getItem('savedSearch'))
        }
        resetAllFilters()
        if(saved) {
          applySavedSearch(savedSearch)
        }
        
        if(!!epubs.autoload) {
          setFilters(obj => ({...obj , trefwoorden : {}}))
          setFilters(obj => ({ ...obj , [epubs.autoload.filter] : { ...obj[epubs.autoload.filter] , [ epubs.autoload.value] : true }})) 
          defaultFilters(epubs.autoload.filter , epubs.autoload.value)
        } 
        if(!!epubs.filterTest) {
          setInput(epubs.filterTest.query)
          Object.keys(filters).map((groep) => {
            if(groep !== 'trefwoorden') {
              Object.keys(filters[groep]).map((sel) => {
              if(epubs.filterTest.filters.includes(sel)) {
                setFilters(obj => ({ ...obj , [groep] : { ...obj[groep] , [sel] : true}}))
              }
            })
            } else {
              epubs.filterTest.trefwoorden.map((tw) => {
                setFilters(obj => ({ ...obj , ['trefwoorden'] : { ...obj['trefwoorden'] , [tw] : true}}))
              })
            }
          })
        } 
      },[])

      const applySavedSearch = (obj) => {
        setInput(obj.typed)
        Object.keys(obj.selFilters).map((groep) => {
          obj.selFilters[groep].map((sel) => {
            if(groep === 'trefwoorden') {
              setFilters(obj => ({ ...obj , ['trefwoorden'] : { ...obj['trefwoorden'] , [sel] : true}}))
            } else {
              setFilters(obj => ({ ...obj , [groep] : { ...obj[groep] , [sel] : true}}))
            }
          })
        })
      }

    const handleChange = (e , {value }) => {
        setInput(value)
        applyAllFilters(value , myFilters)
    }

    const defaultFilters = (group,value) => {
      resetAllFilters()
      setInput("")
      setActivePage(1)
        if(!!!value) { setResults(Object.entries(epubs.data)) } 
        else {
          setFilters(obj => ({ ...obj , [group] : { ...obj[group] , [value] : true}}))
      }
    }

    const filterCounter = ( set ) => {
    
      let countFilters = {}
      for(const groep in filters) {
        countFilters[groep] = [] 
        //if(groep !== skipper) {
        for(const sel in filters[groep]) {
          //countFilters[groep] = []
            if(groep !== 'uitgelicht') {
              countFilters[groep].push({
                value : sel ,
                count : set.filter(item => item[1][groep] !== null && item[1][groep].includes(sel)).length ,
                checked : filters[groep][sel]
              })
            } else {
              countFilters[groep].push({
                value : sel ,
                count : set.filter(item => item[1][groep]===true).length ,
                checked : filters[groep][sel]
              })
            }
          
        }
      }
      
      Object.keys(countFilters).map((arr,k) => {
          countFilters[arr].sort((a,b) => { 
            if(+b.checked > +a.checked) return 1
            if(+b.checked < +a.checked) return -1

            if(b.count > a.count) return 1
            if(b.count < a.count) return -1
          })
      })
      setFilterCount(countFilters)
    }

    useEffect(() => {
      setActivePage(1)
      setMyFilterCount(0)
      let trueFilters = {}
      let uri = ''
      for(const groep in filters) {
        trueFilters[groep] = []
        for(const sel in filters[groep]) {
          if(filters[groep][sel]) {
            trueFilters[groep].push(sel)
            setMyFilterCount(myFilterCount+ 1)
          }
        }
      }
      setMyFilters(trueFilters)
      applyAllFilters( input , trueFilters )
    },[filters])

    const applyAllFilters = ( typed , selFilters ) => {
      sessionStorage.setItem('savedSearch' , JSON.stringify({typed , selFilters}))
      setActivePage(1)
      let filtered
      if(input !== "") {
        filtered  = Object.entries(epubs.data).filter(item => item[1].titel !== null && item[1].titel.toLowerCase().includes(typed.toLowerCase()) || item[1].beschrijving !== null && item[1].beschrijving.toLowerCase().includes(typed.toLowerCase()) || (item[1].trefwoorden !== null && item[1].trefwoorden.some(tw => tw !== null && (tw.includes(typed.toLowerCase())))) || (item[1].uitgever !== null && item[1].uitgever.toLowerCase().includes(typed.toLowerCase())) )
      } else {
        filtered = Object.entries(epubs.data)
      }
      let searchSet = filtered
      for(const field in selFilters) {
        if(selFilters[field].length > 0 && field !== "uitgelicht") {
          filtered = filtered.filter(item => selFilters[field].some(v => item[1][field] !== null && (item[1][field].includes(v))))
          filterCounter(searchSet)
        }
        //UITGELICHT
        if(selFilters[field].length > 0 && field === "uitgelicht") {
          filtered  = filtered.filter(item => item[1].uitgelicht)
          filterCounter(searchSet)
        }

        if(selFilters[field].length === 0) {
          filterCounter(filtered)
        }

      }
      filtered.sort((a,b) => {
        return b[1].uitgelicht - a[1].uitgelicht
      })
      filterCounter(filtered)
      setResults(filtered)
      createUrl(typed , selFilters)
    }

    const createUrl = ( typed = '', selFilters = {} ) => {
      let uriString = []
      let twString = []
      Object.keys(selFilters).map((groep) => {
        selFilters[groep].map((veld) => {
          if(groep !== "trefwoorden") {
            uriString.push(veld)
          } else {
            twString.push(veld)
          }
        })

      })
      let fs = (uriString.length > 0) ?  `+${uriString.join('+')}` : ''
      let ts = (twString.length > 0) ?  (uriString.length ===  0) ? `+|${twString.join('+')}`: `|${twString.join('+')}` : ''
      let link = ''
      if(typed === '' && uriString.length === 0 && twString.length === 0) {
        link = shareUrl
      } else {
        link =  shareUrl + 'share/' + encodeURIComponent(typed + fs + ts)
      }
      setUrl(link)
    }

    const myFilterIcons = {
      trefwoorden : 'tag' ,
      uitgavenvorm : 'book' ,
      domein : 'bullseye' ,
      mediatheek : 'home' ,
      //opleiding : 'graduation cap' ,
      uitgelicht : 'hand point right'
    }

    return (
      <Container fluid>
      <Container className="App">
        <ApplicationHeader 
          user={user}
        />
        <Suspense fallback={<Loading />}>   
          <Grid stackable columns='equal'>
            <Grid.Row>
              <Grid.Column>
              <Input fluid placeholder={t('placeholder')} 
                onChange={handleChange}
                value={input}
              />
              </Grid.Column>
              <Grid.Column width={3}>
                <Button 
                fluid
                onClick={() => {
                  resetAllFilters()
                  navigate(homep)
                }
                  }>Reset</Button>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>{t('mijnFilters')} : </Grid.Column>
              <Grid.Column>         
              { myFilterCount > 0 &&
              Object.keys(myFilters).map((f) => {
                if(myFilters[f].length > 0) {
                  return myFilters[f].map((tf) => {
                    if(f !== 'trefwoorden') {
                      return <Label>
                      <Icon name={myFilterIcons[f]} />
                      {t(`taxonomieItems.${tf}`)}
                      <Icon name='delete' onClick={() => setFilters(obj => ({ ...obj , [f] : { ...obj[f] , [tf] : false}}))} /></Label>
                    } else {
                      return <Label>
                      <Icon name={myFilterIcons[f]} />
                      {tf.split('_')[0]}
                      <Icon name='delete' onClick={() => setFilters(obj => ({ ...obj , [f] : { ...obj[f] , [tf] : false}}))} /></Label>
                    }
                  })
                } 
              })
              }
              { myFilterCount === 0 &&
                  <Label><Icon name='filter' />{t('noFilters')}</Label>
              }
              </Grid.Column>
            </Grid.Row>
            { !!url &&
                  <Grid.Row >
                    <Grid.Column width={4}>
                      {!!copied && 
                        <>{t('naarKlembord')}</>
                      }
                      {!!!copied && 
                        <>{t('deelMij')}:</>
                      }
                    </Grid.Column>
                    <Grid.Column>
                        <Label style={{cursor : 'pointer'}} color={copied ? 'green' : 'grey'} onClick={() => copyToClipBoard(url)}>
                          {url}
                        </Label>
                    </Grid.Column>
                  </Grid.Row>
            }
            <Grid.Row>
            {width > 767 &&
              <Grid.Column width={5}>
              <Filters 
                filters={filters} 
                filterCount = {filterCount}
                onChange={(cb) => {
                  let value = cb.value
                  setFilters(obj => ({ ...obj , [value.filterGroep] : { ...obj[value.filterGroep] , [value.veld] : cb.checked}}))
                }}
              />
            </Grid.Column>
            }
            {width <= 767 &&
              <Grid.Column width={5}>
                <Button primary fluid onClick={() => setFilterModal(true)}>
                  <Icon name="filter" />
                </Button>
              </Grid.Column>
            }
            <Grid.Column>
              {results && results.length > 0 &&
                <ResultList 
                  data={results} 
                  page={activePage}
                />
              }
              {results && results.length === 0 &&
                <Segment>
                  {t('geenResultaten')}
                </Segment>
              }
            </Grid.Column>
            </Grid.Row>
            
          </Grid>
          <Sidebar
            width='very wide'
            as={Segment}
            inverted color='blue'
            animation='overlay'
            icon='labeled'
            vertical
            visible={filterModal}
            style={{textAlign : 'left'}}
            onHide={() => {
              setFilterModal(false)
            }}
          >
            <Header as='h1' style={{textAlign: 'center'}}>{t('filters')}</Header>
            <Container>
              <Segment>
                <Button onClick={() => setFilterModal(false)}>{t('toon')} {results.length} {t('resultaten')}</Button>
                <Button  negative onClick={() => { 
                  resetAllFilters()
                  setFilterModal(false)
                  }}>Reset
                </Button>
              </Segment>
            </Container>
            <Divider />
            
            <Filters 
                filters={filters} 
                filterCount={filterCount}
                onChange={(cb) => {
                  let value = cb.value
                  setFilters(obj => ({ ...obj , [value.filterGroep] : { ...obj[value.filterGroep] , [value.veld] : cb.checked}}))
                }}
            />
            
          </Sidebar>
        </Suspense>
      </Container>
      <ApplicationFooter 
        version={pjson.version}
      />
      </Container>
    );
  }

  export default App;